module.exports = "<div class=\"modal-archismall\" id=\"resume-application\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">\n            Account ArchiSMALL già in uso\n        </h3>\n    </div>\n\n    <div class=\"modal-body\">\n        Il tuo account ArchiSMALL è attualmente in uso su un altro dispositivo o pagina. Seleziona Riprendi per ripristinare l'utilizzo\n        in questa pagina.\n    </div>\n\n    <div class=\"modal-footer\">\n        <a ng-click=\"resume();\">Riprendi</a>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/components/resume-application-modal/resume-application-modal.html
// module id = 1369
// module chunks = 0